(() => {
  const header = document.querySelector('[data-header]');
  if (!header) return;

  const SCROLLED_CLASS = 'll-header--scrolled';
  const heroContent = document.querySelector('.ll-page-hero__content');

  if (heroContent) {
    const update = () => {
      const h = header.getBoundingClientRect();
      const c = heroContent.getBoundingClientRect();
      const intersects = c.top < h.bottom && c.bottom > h.top;
      header.classList.toggle(SCROLLED_CLASS, intersects);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    return;
  }

  const trackedElements = document.querySelectorAll('[data-scroll-track]');

  const isScrolled = () => {
    if (window.scrollY > 0) return true;
    for (const el of trackedElements) {
      if (el.scrollTop > 0) return true;
    }
    return false;
  };

  const update = () => {
    header.classList.toggle(SCROLLED_CLASS, isScrolled());
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  trackedElements.forEach((el) => {
    el.addEventListener('scroll', update, { passive: true });
  });
})();
